import { render } from "./PayFormPaypal.vue?vue&type=template&id=706120ed"
import script from "./PayFormPaypal.vue?vue&type=script&lang=js"
export * from "./PayFormPaypal.vue?vue&type=script&lang=js"

import "./PayFormPaypal.vue?vue&type=style&index=0&id=706120ed&lang=css"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__